// extracted by mini-css-extract-plugin
export default {"palette":"Palette_palette__CbFxi","list":"Palette_list__Bmdza","premium":"Palette_premium__f4JL2","dragDrop":"Palette_dragDrop__QhHht","basic":"Palette_basic__JhDj+"};